<template lang="pug">
#emergency-transport-patient-register(v-cloak)
  .box
    .box-header.with-border.register-header
      .title
        span 救急搬送 新規作成

    .box-body.register-body
      //- 1. 担当職員 (必須)
      FormInput(
        v-model="assignedStaffName"
        key-name="担当職員"
        name="assigned-staff-name"
        type="text"
        placeholder="氏名を入力してください"
        :maxlength="100"
        :validation-rules="{ required: true, max: 100 }"
        :styles="{ width: '340px' }"
        required
      )

      //- 2. 搬送先病院 (必須)
      FormInputSelect(
        v-model="targetFacilityId"
        key-name="搬送先病院"
        name="target-facility-id"
        :options="targetFacilityOptions"
        :validation-rules="{ required: true }"
        :styles="{ width: '340px' }"
        required
      )

      //- 3. 利用者名 (必須)
      FormInputRadio(
        v-model="residentType"
        key-name="利用者名"
        name="resident-type"
        :options="[{ value: 'registered', label: '登録済' }, { value: 'unregistered', label: '未登録' }]"
        :validation-rules="{ required: true }"
        :styles="{ width: '340px' }"
        required
      )
      //- 登録済利用者の場合
      FormInputSelect(
        v-if="residentType === 'registered'"
        v-model="selectedResidentSortKey"
        key-name=""
        name="resident-id"
        :options="residentOptions"
        :validation-rules="{ required: true }"
        :styles="{ width: '340px' }"
        @change="onSelectResident"
      )
      //- 未登録利用者の場合
      FormInput(
        v-if="residentType === 'unregistered'"
        v-model="name"
        key-name=""
        name="name"
        type="text"
        placeholder="氏名を入力してください"
        :maxlength="100"
        :validation-rules="{ required: true, max: 100 }"
        :styles="{ width: '340px' }"
      )

      //- 4. 生年月日
      FormInputSplitDate(
        key-name="生年月日"
        :year.sync="birthdayYear"
        :month.sync="birthdayMonth"
        :day.sync="birthdayDay"
      )

      //- 5. 性別
      FormInputGender(
        v-model="gender"
        key-name="性別"
        hide-none
      )

      //- 6. 身長
      FormInput(
        v-model="height"
        key-name="身長"
        name="height"
        type="text"
        placeholder="163.2"
        unit-text="cm"
        :validation-rules="{ custom_decimal: true }"
        :styles="{ width: '120px', minWidth: '120px' }"
      )

      //- 7. 体重
      FormInput(
        v-model="weight"
        key-name="体重"
        name="weight"
        type="text"
        placeholder="51.2"
        unit-text="kg"
        :validation-rules="{ custom_decimal: true }"
        :styles="{ width: '120px', minWidth: '120px' }"
      )

      //- 8. 血液型
      FormInputRadio(
        v-model="bloodType"
        key-name="血液型"
        name="blood-type"
        :options="[{ value: 'A', label: 'A' }, { value: 'B', label: 'B' }, { value: 'O', label: 'O' }, { value: 'AB', label: 'AB' }]"
      )

      //- 9. 家族
      .register-row
        .register-group
          .register-key
            span.key-name 家族
          .register-value.d-flex.flex-column.align-items-start
            .register-card-box.w-100.mb-2(v-for="(family, index) in families" :key="index")
              .card-body
                .family-item-row
                  FormInput(
                    v-model="family.name"
                    key-name="氏名"
                    :name="'family-name-' + index"
                    type="text"
                    placeholder="氏名を入力してください。"
                    :maxlength="100"
                  )
                  FormInput(
                    v-model="family.tel"
                    key-name="電話番号"
                    :name="'family-tel-' + index"
                    type="text"
                    placeholder="電話番号を入力してください。"
                    :maxlength="20"
                  )
                .d-flex.flex-row.align-items-center.justify-content-end.w-100
                  button.btn(v-if="1 < families.length" @click="deleteFamily(index)" type="button") 削除
                  
            .d-flex.flex-row.align-items-center.justify-content-end.w-100
              button.btn(@click="addFamily" type="button") 追加

      //- 10. かかりつけ医
      .register-row
        .register-group
          .register-key
            span.key-name かかりつけ医
          .register-value.d-flex.flex-column.align-items-start
            .register-card-box.w-100.mb-2
              .card-body
                FormInput(
                  v-model="primaryHospitalName"
                  key-name="病院名"
                  name="primary-hospital-name"
                  type="text"
                  placeholder="病院名を入力してください。"
                  :maxlength="100"
                )
                FormInput(
                  v-model="primaryDoctorName"
                  key-name="担当医"
                  name="primary-doctor-name"
                  type="text"
                  placeholder="担当医師名を入力してください。"
                  :maxlength="100"
                )
                FormInput(
                  v-model="primaryHospitalTel"
                  key-name="電話番号"
                  name="primary-hospital-tel"
                  type="text"
                  placeholder="電話番号を入力してください。"
                  :maxlength="20"
                )

      //- 11. 救急搬送の経緯 (必須 / 10行)
      FormTextarea(
        v-model="note"
        key-name="救急搬送の経緯"
        name="note"
        placeholder="救急搬送の経緯をなるべく詳しくお書きください。"
        :maxlength="1000"
        :rows="10"
        :validation-rules="{ required: true, max: 1000 }"
        :styles="{ width: '100%' }"
        required
      )

      //- 12. 最終バイタルサイン
      .register-row
        .register-group
          .register-key
            span.key-name 最終バイタルサイン
          .register-value.d-flex.flex-column.align-items-start
            .register-card-box.w-100.mb-2
              .card-body
                //- 血圧
                .register-row.mb-2
                  .register-group
                    .register-key
                      span.key-name 血圧
                    .register-value.d-flex.flex-row.align-items-center.flex-wrap
                      span.mr-1.ml-0 最高
                      b-form-input.mr-1(
                        v-model="maxBloodPressure"
                        name="max-blood-pressure"
                        type="number"
                        placeholder="110"
                        style="width: 90px;"
                      )
                      span.mr-3 mmHg
                      span.mr-1 最低
                      b-form-input.mr-1(
                        v-model="minBloodPressure"
                        name="min-blood-pressure"
                        type="number"
                        placeholder="70"
                        style="width: 90px;"
                      )
                      span mmHg
                //- 脈拍
                FormInput(
                  v-model="pulse"
                  key-name="脈拍"
                  name="pulse"
                  type="number"
                  placeholder="68"
                  unit-text="回/分"
                  :styles="{ width: '120px', minWidth: '120px' }"
                )
                //- 呼吸
                FormInput(
                  v-model="respiration"
                  key-name="呼吸"
                  name="respiration"
                  type="number"
                  placeholder="15"
                  unit-text="回/分"
                  :styles="{ width: '120px', minWidth: '120px' }"
                )
                //- 体温
                FormInput(
                  v-model="bodyTemperature"
                  key-name="体温"
                  name="body-temperature"
                  type="text"
                  placeholder="36.7"
                  unit-text="℃"
                  :validation-rules="{ custom_decimal: true }"
                  :styles="{ width: '120px', minWidth: '120px' }"
                )
                //- サチュレーション (SpO2)
                FormInput(
                  v-model="spo2"
                  key-name="サチュレーション (SpO2)"
                  name="spo2"
                  type="number"
                  placeholder="98"
                  unit-text="%"
                  :styles="{ width: '120px', minWidth: '120px' }"
                )
                //- 特記事項 (3行)
                FormTextarea(
                  v-model="specialNotes"
                  key-name="特記事項"
                  name="special-notes"
                  placeholder="特記事項があれば入力してください。"
                  :maxlength="1000"
                  :rows="3"
                  :styles="{ width: '100%' }"
                )

      //- 14. 禁忌・アレルギー (3行)
      FormTextarea(
        v-model="allergiesAndContraindications"
        key-name="禁忌・アレルギー"
        name="allergies-and-contraindications"
        placeholder="入力してください。（無しの場合は「無し」とお書きください。）"
        :maxlength="1000"
        :rows="3"
        :styles="{ width: '100%' }"
      )

      //- 15. 既往歴 (3行)
      FormTextarea(
        v-model="medicalHistory"
        key-name="既往歴"
        name="medical-history"
        placeholder="入力してください。（無しの場合は「無し」とお書きください。）"
        :maxlength="1000"
        :rows="3"
        :styles="{ width: '100%' }"
      )

      //- 16. 服薬中の薬 (3行)
      FormTextarea(
        v-model="medications"
        key-name="服薬中の薬"
        name="medications"
        placeholder="入力してください。（無しの場合は「無し」とお書きください。）"
        :maxlength="1000"
        :rows="3"
        :styles="{ width: '100%' }"
      )

      //- 17. その他の連絡事項 (3行)
      FormTextarea(
        v-model="otherInfo"
        key-name="その他の連絡事項"
        name="other-info"
        placeholder="入力してください。"
        :maxlength="1000"
        :rows="3"
        :styles="{ width: '100%' }"
      )

      //- エラーメッセージ
      .register-row(v-show="errorMessage")
        .register-group
          .register-value
            .error-message {{ errorMessage }}

    .box-footer.with-border.register-footer
      ValidationAlert(v-model="showValidationAlert")
      .buttons
        button.btn.register-btn(@click="showConfirmModal" type="button") 登録
        button.btn.cancel-btn(@click="gotoList" type="button") キャンセル

  OkCancelModal(v-model="showRegisterModal" title="救急搬送情報を登録しますか？" @ok="register")
  OkModal(v-model="showRegisterSuccessModal" title="登録に成功しました。" @ok="gotoList")

  PageLoading(:isBusy="isBusy" :message="loadingMessage")
</template>

<script lang="ts">
import { Component, Inject, Vue, Watch } from "vue-property-decorator";
import { userStore } from "@/store/store";
import { errorHandle } from "@/errorHandler";

import CustomValidate from "@/commons/utils/CustomValidate";
import { PcUrl } from "@/commons/constants/PcUrl";
import EmergencyTransportPatientsService, { EmergencyTransportPatientPostModel } from "@/commons/services/EmergencyTransportPatients";
import OtherOfficeConnectionsService, { OtherOfficeConnectionGetModel } from "@/commons/services/OtherOfficeConnections";
import ResidentsService, { ResidentGetModel } from "@/commons/services/Residents";

import PageLoading from "@/pc/basics/PageLoading.vue";
import ValidationAlert from "@/pc/basics/ValidationAlertByValidator.vue";
import OkCancelModal from "@/pc/basics/OkCancelModal.vue";
import OkModal from "@/pc/basics/OkModal.vue";

import FormInput from "@/pc/components/forms/FormInput.vue";
import FormInputSelect from "@/pc/components/forms/FormInputSelect.vue";
import FormInputRadio from "@/pc/components/forms/FormInputRadio.vue";
import FormInputSplitDate from "@/pc/components/forms/FormInputSplitDate.vue";
import FormInputGender from "@/pc/components/forms/FormInputGender.vue";
import FormTextarea from "@/pc/components/forms/FormTextarea.vue";

export interface FamilyFormItem {
  name: string;
  tel: string;
}

/**
 * ### 救急搬送 新規登録画面
 */
@Component({
  components: {
    PageLoading,
    ValidationAlert,
    OkCancelModal,
    OkModal,
    FormInput,
    FormInputSelect,
    FormInputRadio,
    FormInputSplitDate,
    FormInputGender,
    FormTextarea
  },
  name: "EmergencyTransportPatientRegister",
  $_veeValidate: { validator: "new" }
})
export default class EmergencyTransportPatientRegister extends Vue {
  /** 救急搬送患者サービス */
  @Inject("EmergencyTransportPatientsService") emergencyTransportPatientsService!: EmergencyTransportPatientsService;
  /** 他事業所連携管理サービス */
  @Inject("OtherOfficeConnectionsService") otherOfficeConnectionsService!: OtherOfficeConnectionsService;
  /** 利用者サービス */
  @Inject("ResidentsService") residentsService!: ResidentsService;

  /** ページ全体ローディング表示可否 */
  isBusy: boolean = false;
  /** ローディングメッセージ */
  loadingMessage: string = "";

  /** 1. 担当職員 */
  assignedStaffName: string = "";

  /** 2. 搬送先病院 ID */
  targetFacilityId: number | null = null;
  /** 搬送先病院 選択肢 */
  targetFacilityOptions: Array<{ value: number | string; label: string }> = [];

  /** 3. 利用者区分 (登録済: "registered" / 未登録: "unregistered") */
  residentType: string = "";

  /** 選択された登録済利用者のソートキー */
  selectedResidentSortKey: string | null = null;
  /** 登録済利用者 選択肢 */
  residentOptions: Array<{ value: string | string; label: string }> = [];
  /** 取得済み全利用者データ一覧 */
  residentList: Array<ResidentGetModel> = [];

  /** 利用者名 */
  name: string = "";

  /** 4. 生年月日 */
  birthdayYear: string = "";
  birthdayMonth: string = "";
  birthdayDay: string = "";

  /** 5. 性別 (男性 / 女性) */
  gender: string = "";

  /** 6. 身長 (cm) */
  height: string = "";

  /** 7. 体重 (kg) */
  weight: string = "";

  /** 8. 血液型 (A / B / O / AB) */
  bloodType: string = "";
  bloodTypeOptions: string[] = ["A", "B", "O", "AB"];

  /** 9. 家族一覧 */
  families: Array<FamilyFormItem> = [{ name: "", tel: "" }];

  /** 10. かかりつけ医 */
  primaryHospitalName: string = "";
  primaryDoctorName: string = "";
  primaryHospitalTel: string = "";

  /** 11. 救急搬送の経緯 (必須 / 10行) */
  note: string = "";

  /** 12. 最終バイタルサイン */
  maxBloodPressure: string = "";
  minBloodPressure: string = "";
  pulse: string = "";
  respiration: string = "";
  bodyTemperature: string = "";
  spo2: string = "";

  /** 13. 特記事項 (3行) */
  specialNotes: string = "";

  /** 14. 禁忌・アレルギー (3行) */
  allergiesAndContraindications: string = "";

  /** 15. 既往歴 (3行) */
  medicalHistory: string = "";

  /** 16. 服薬中の薬 (3行) */
  medications: string = "";

  /** 17. その他の連絡事項 (3行) */
  otherInfo: string = "";

  /** 登録確認モーダル表示可否 */
  showRegisterModal: boolean = false;
  /** 登録完了モーダル表示可否 */
  showRegisterSuccessModal: boolean = false;

  /** バリデーションアラート表示可否 */
  showValidationAlert: boolean = false;
  /** エラーメッセージ */
  errorMessage: string = "";

  /**
   * ### vue lifecycle created
   */
  public created(): void {
    CustomValidate.addCustomValidate(this.$validator);
    return;
  }

  public async mounted(): Promise<void> {
    await this.createView();
    return;
  }

  /**
   * ### 画面情報作成
   */
  public async createView(): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "読込み中...";

    try {
      // 搬送先病院選択肢の取得
      const connections: Array<OtherOfficeConnectionGetModel> = await this.otherOfficeConnectionsService.gets(userStore);
      this.targetFacilityOptions = connections.map((conn) => ({
        value: conn.registerdFacilityId,
        label: conn.officeName
      }));

      // 利用者選択肢の取得
      const residents: Array<ResidentGetModel> = await this.residentsService.gets(userStore);
      this.residentList = residents || [];
      this.residentOptions = this.residentList.map((res) => ({
        value: res.residentsSortKey,
        label: res.name
      }));
    } catch (error) {
      errorHandle(error, this);
    } finally {
      this.isBusy = false;
    }

    return;
  }

  /**
   * ### 利用者区分変更時イベント（入力項目の初期化）
   */
  @Watch("residentType")
  public onChangeResidentType(): void {
    this.selectedResidentSortKey = null;
    this.name = "";
    this.birthdayYear = "";
    this.birthdayMonth = "";
    this.birthdayDay = "";
    this.gender = "";
  }

  /**
   * ### 登録済利用者選択時イベント（データの自動補完）
   */
  @Watch("selectedResidentSortKey")
  public onSelectResident(sortKey: string | null): void {
    if (!sortKey) return;
    const target = this.residentList.find((r) => r.residentsSortKey === sortKey);
    if (!target) return;

    this.name = target.name || "";

    // 生年月日の自動反映 (YYYYMMDDhhmmssSSS 形式)
    if (target.birthday) {
      const birthdayStr = String(target.birthday);
      if (birthdayStr.length >= 8) {
        this.birthdayYear = birthdayStr.substring(0, 4);
        this.birthdayMonth = String(Number(birthdayStr.substring(4, 6)));
        this.birthdayDay = String(Number(birthdayStr.substring(6, 8)));
      }
    }

    // 性別の自動反映
    if (target.gender && target.gender !== "無回答") {
      this.gender = target.gender;
    } else {
      this.gender = "";
    }

    return;
  }

  /**
   * ### 家族追加
   */
  addFamily(): void {
    this.families.push({ name: "", tel: "" });
    return;
  }

  /**
   * ### 家族削除
   */
  deleteFamily(index: number): void {
    if (this.families.length > 1) {
      this.families.splice(index, 1);
    }
    return;
  }

  /**
   * ### 登録確認モーダル表示
   */
  async showConfirmModal(): Promise<void> {
    const validationResult: boolean = await this.$validator.validateAll();
    if (validationResult === true) {
      this.showValidationAlert = false;
      this.showRegisterModal = true;
    } else {
      this.showValidationAlert = true;
    }
    return;
  }

  /**
   * ### 登録実行
   */
  async register(): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "登録中...";

    try {
      const requestBody = this.createRequestBody();
      await this.emergencyTransportPatientsService.post(userStore, requestBody);

      this.showRegisterSuccessModal = true;
    } catch (error) {
      errorHandle(error, this);
    } finally {
      this.isBusy = false;
    }

    return;
  }

  private createRequestBody(): EmergencyTransportPatientPostModel {
    const validFamilies = this.families.filter((f) => (f.name && f.name.trim() !== "") || (f.tel && f.tel.trim() !== ""));

    return {
      targetFacilityId: Number(this.targetFacilityId),
      residentSortKey: this.selectedResidentSortKey ? this.selectedResidentSortKey : undefined,
      name: this.name,
      assignedStaffName: this.assignedStaffName,
      note: this.note,
      birthday: this.getBirthdayNumber() || undefined,
      gender: this.gender ? this.gender : undefined,
      height: this.height ? this.height : undefined,
      weight: this.weight ? this.weight : undefined,
      bloodType: this.bloodType ? this.bloodType : undefined,
      families: validFamilies.length > 0 ? validFamilies : undefined,
      primaryHospitalName: this.primaryHospitalName ? this.primaryHospitalName : undefined,
      primaryDoctorName: this.primaryDoctorName ? this.primaryDoctorName : undefined,
      primaryHospitalTel: this.primaryHospitalTel ? this.primaryHospitalTel : undefined,
      maxBloodPressure: this.maxBloodPressure ? Number(this.maxBloodPressure) : undefined,
      minBloodPressure: this.minBloodPressure ? Number(this.minBloodPressure) : undefined,
      pulse: this.pulse ? Number(this.pulse) : undefined,
      respiration: this.respiration ? Number(this.respiration) : undefined,
      bodyTemperature: this.bodyTemperature ? this.bodyTemperature : undefined,
      spo2: this.spo2 ? Number(this.spo2) : undefined,
      specialNotes: this.specialNotes ? this.specialNotes : undefined,
      allergiesAndContraindications: this.allergiesAndContraindications ? this.allergiesAndContraindications : undefined,
      medicalHistory: this.medicalHistory ? this.medicalHistory : undefined,
      medications: this.medications ? this.medications : undefined,
      otherInfo: this.otherInfo ? this.otherInfo : undefined
    };
  }

  /**
   * ### 生年月日の数値変換
   *
   * 分割されている生年月日を結合し、YYYYMMDD000000000 形式の数値に変換する
   */
  private getBirthdayNumber(): number | null {
    if (this.birthdayYear || this.birthdayMonth || this.birthdayDay) {
      let month: string = String(this.birthdayMonth);
      if (month.length === 1) {
        month = `0${month}`;
      }
      let day: string = String(this.birthdayDay);
      if (day.length === 1) {
        day = `0${day}`;
      }

      return Number(`${this.birthdayYear}${month}${day}000000000`);
    }

    return null;
  }

  /**
   * ### 救急搬送一覧画面へ遷移する
   */
  gotoList(): void {
    this.$router.push(PcUrl.OtherOfficeEmergencyTransports);
    return;
  }
}
</script>

<style lang="scss" scoped>
#emergency-transport-patient-register {
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;

  .register-card-box {
    border: 1px solid #ced4da;
    border-radius: 6px;
    // margin: 0 20px;
    // padding: 16px;
    background-color: #fff;
  }

  .register-btn,
  .cancel-btn {
    width: 120px;
  }
}
</style>
